import './privacyOpsWidgets.less'
import {
  ACTION_PRIVACY_RIGHTS,
  PrivacyAssessmentsWidget,
  fetchPrivacyAssessments,
  resetPrivacyAssessments
} from './privacyOpsWidgetsSlice'
import { RootState } from '../../../../../rootReducer'
import { getShowLoader } from '../../../../../reducers/requestReducer'
import LoaderView from '../../../../../components/Loader/loader'
import historyService from '../../../../../services/historyService'
import {
  FILTER_REVIEW_STATUS,
  PAGE_VIEW_KEY,
  PAGE_VIEW_VALUES,
  PiaProcessFilter,
  URL_DEFINED_PROCESSES,
  URL_PIA,
  URL_ROPA
} from '../../../../../constants'
import { FeatureFlags } from '../../../../../configs/featureFlagSlice'
import { getUpdatedUrl } from '../../../../../utils/urlUtil'
import { mockPrivacyAssessmentsWidgetData } from '../../../renderer/utils/widgetMockdata'
import { connect } from 'react-redux'
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Typography } from '@lightbeamai/design-system'

interface OwnProps {
  useMockData?: boolean
}

interface StateProps {
  privacyAssessments?: PrivacyAssessmentsWidget
  featureFlags: FeatureFlags
  showLoader: boolean
}

interface DispatchProps {
  fetchPrivacyAssessments: () => void
  resetPrivacyAssessments: () => void
}

type PrivacyAssessmentsComponentProps = StateProps & DispatchProps & OwnProps

const PrivacyAssessmentsWidget = (props: PrivacyAssessmentsComponentProps) => {
  const {
    privacyAssessments,
    showLoader = false,
    featureFlags,
    useMockData = false,
    fetchPrivacyAssessments,
    resetPrivacyAssessments
  } = props

  const {
    // aiGovernanceAssessmentsNeedReview = 0,
    // aiGovernanceAssessmentsTotal = 0,
    piaAssessmentsNeedReview = 0,
    piaAssessmentsTotal = 0,
    ropaProcessesNeedReview = 0,
    ropaProcessesTotal = 0
  } = privacyAssessments || {}

  const intl = useIntl()

  useEffect(() => {
    if (useMockData) return
    fetchPrivacyAssessments()
    return () => resetPrivacyAssessments()
  }, [fetchPrivacyAssessments, resetPrivacyAssessments, useMockData])

  // AI Governance
  // const aiGovernancePercentage =
  //   Math.round((aiGovernanceAssessmentsNeedReview / aiGovernanceAssessmentsTotal) * 100) || 0
  // const handleOpenAiGovernance = () => historyService.push(URL_AI_GOVERNANCE)

  // PIA
  const piaPercentage = Math.round((piaAssessmentsNeedReview / piaAssessmentsTotal) * 100) || 0
  const handleOpenPiaListAll = () => {
    const url = getUpdatedUrl({
      pathName: URL_PIA + URL_DEFINED_PROCESSES,
      pageName: URL_DEFINED_PROCESSES,
      pageQueryParams: {
        [PAGE_VIEW_KEY]: PAGE_VIEW_VALUES.list
      }
    })
    historyService.push(url)
  }
  const handleOpenPiaListReviewed = () => {
    const url = getUpdatedUrl({
      pathName: URL_PIA + URL_DEFINED_PROCESSES,
      pageName: URL_DEFINED_PROCESSES,
      pageQueryParams: {
        [PAGE_VIEW_KEY]: PAGE_VIEW_VALUES.list,
        [FILTER_REVIEW_STATUS]: PiaProcessFilter.reviewPending
      }
    })
    historyService.push(url)
  }

  // ROPA
  const ropaPercentage = Math.round((ropaProcessesNeedReview / ropaProcessesTotal) * 100) || 0
  const handleOpenRopa = () => historyService.push(URL_ROPA + URL_DEFINED_PROCESSES)

  return (
    <div className="lb-widget-card policy-assessments xs-p-16">
      <div className="privacy-ops-widget" data-test-id="privacy-assessments-widget">
        <Typography color="primary" variant="h6">
          {intl.formatMessage({ id: 'privacyOpsWidget.privacyAssessments' })}
        </Typography>

        <div className="widget-bars">
          {/* <div className="widget-section clickable" onClick={handleOpenAiGovernance}>
          <Typography color="primary" className="xs-mb-0" type="medium" variant="baseMinus2">
            {intl.formatMessage({ id: 'privacyOpsWidget.aiGovernance' })}
          </Typography>

          <div className="progress-bar">
            <div className="progress" style={{ width: aiGovernancePercentage + '%' }} />
          </div>
          <div className="counts row" title={aiGovernanceAssessmentsNeedReview + ''}>
            <div className="divider" />
            <div className="count-box row">
              <Typography color="primary" className="xs-mb-0" type="strong" variant="baseMinus2">
                {intl.formatNumber(aiGovernanceAssessmentsNeedReview, { notation: 'compact' })}
              </Typography>
              <Typography
                color="secondary"
                className="xs-ml-4 xs-mb-0"
                type="normal"
                variant="baseMinus2"
              >
                {intl.formatMessage({ id: 'reviewPending' })}
              </Typography>
            </div>
            <div className="divider" />
            <div className="count-box row" title={aiGovernanceAssessmentsTotal + ''}>
              <Typography color="primary" className="xs-mb-0" type="strong" variant="baseMinus2">
                {intl.formatNumber(aiGovernanceAssessmentsTotal, { notation: 'compact' })}
              </Typography>
              <Typography
                color="secondary"
                className="xs-ml-4 xs-mb-0"
                type="normal"
                variant="baseMinus2"
              >
                {intl.formatMessage({ id: 'total' })}
              </Typography>
            </div>
          </div>
        </div> */}
          {featureFlags?.piaFeature && (
            <div className="widget-section clickable">
              <Typography
                color="primary"
                className="xs-mb-0"
                type="medium"
                variant="baseMinus2"
                onClick={handleOpenPiaListAll}
              >
                {intl.formatMessage({ id: 'privacyOpsWidget.pia' })}
              </Typography>
              <div className="progress-bar" onClick={handleOpenPiaListAll}>
                <div className="progress" style={{ width: piaPercentage + '%' }} />
              </div>
              <div className="counts row" title={piaAssessmentsNeedReview + ''}>
                <div className="divider" />
                <div className="count-box row" onClick={handleOpenPiaListReviewed}>
                  <Typography
                    color="primary"
                    className="xs-mb-0"
                    type="strong"
                    variant="baseMinus2"
                  >
                    {intl.formatNumber(piaAssessmentsNeedReview, { notation: 'compact' })}
                  </Typography>
                  <Typography
                    color="secondary"
                    className="xs-ml-4 xs-mb-0"
                    type="normal"
                    variant="baseMinus2"
                  >
                    {intl.formatMessage({ id: 'reviewPending' })}
                  </Typography>
                </div>
                <div className="divider" />
                <div
                  className="count-box row"
                  title={piaAssessmentsTotal + ''}
                  onClick={handleOpenPiaListAll}
                >
                  <Typography
                    color="primary"
                    className="xs-mb-0"
                    type="strong"
                    variant="baseMinus2"
                  >
                    {intl.formatNumber(piaAssessmentsTotal, { notation: 'compact' })}
                  </Typography>
                  <Typography
                    color="secondary"
                    className="xs-ml-4 xs-mb-0"
                    type="normal"
                    variant="baseMinus2"
                  >
                    {intl.formatMessage({ id: 'total' })}
                  </Typography>
                </div>
              </div>
            </div>
          )}
          <div className="widget-section clickable" onClick={handleOpenRopa}>
            <Typography
              color="primary"
              className="xs-mb-0 title"
              type="medium"
              variant="baseMinus2"
            >
              {intl.formatMessage({ id: 'privacyOpsWidget.ropa' })}
            </Typography>

            <div className="progress-bar">
              <div className="progress" style={{ width: ropaPercentage + '%' }} />
            </div>
            <div className="counts row" title={ropaProcessesNeedReview + ''}>
              <div className="divider" />
              <div className="count-box row">
                <Typography color="primary" className="xs-mb-0" type="strong" variant="baseMinus2">
                  {intl.formatNumber(ropaProcessesNeedReview, { notation: 'compact' })}
                </Typography>
                <Typography
                  color="secondary"
                  className="xs-ml-4 xs-mb-0"
                  type="normal"
                  variant="baseMinus2"
                >
                  {intl.formatMessage({ id: 'reviewPending' })}
                </Typography>
              </div>
              <div className="divider" />
              <div className="count-box row" title={ropaProcessesTotal + ''}>
                <Typography color="primary" className="xs-mb-0" type="strong" variant="baseMinus2">
                  {intl.formatNumber(ropaProcessesTotal, { notation: 'compact' })}
                </Typography>
                <Typography
                  color="secondary"
                  className="xs-ml-4 xs-mb-0"
                  type="normal"
                  variant="baseMinus2"
                >
                  {intl.formatMessage({ id: 'total' })}
                </Typography>
              </div>
            </div>
          </div>
        </div>

        <LoaderView showLoader={showLoader} />
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => ({
  privacyAssessments: ownProps?.useMockData
    ? mockPrivacyAssessmentsWidgetData
    : state.privacyOpsWidgets.privacyAssessments,
  showLoader: getShowLoader(ACTION_PRIVACY_RIGHTS),
  featureFlags: state.featureFlags
})

const mapDispatchToProps: DispatchProps = {
  fetchPrivacyAssessments,
  resetPrivacyAssessments
}

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(PrivacyAssessmentsWidget)
